<div class="bn-unauthorized">
  <div class="bn-unauthorized__container">
    <img
      alt="Unauthorized"
      class="bn-unauthorized__container__image"
      src="/assets/web-ui/images/bunny-access-denied.svg"
      [ngStyle]="{
        'width.px': 350,
      }" />
    <div class="bn-unauthorized__container__title">401 Unauthorized</div>
    <div class="bn-unauthorized__container__description">You are not authorized to see this page.</div>
    <bn-web-ui-button
      itemStyle="secondary"
      routerLink="/"
      size="lg">
      Go to Overview
    </bn-web-ui-button>
  </div>
</div>
